export interface Province {
    name: string;
}

export const all_provinces: Province[] = [
    {
        name: 'Gauteng'
    },
    {
        name: 'Kwazulu-Natal'
    },
    {
        name: 'Free State'
    },
    {
        name: 'Eastern Cape'
    },
    {
        name: 'Western Cape'
    },
    {
        name: 'Northern Cape'
    },
    {
        name: 'North West'
    },
    {
        name: 'Mpumalanga'
    },
    {
        name: 'Limpopo'
    }
]